module.exports = __webpack_public_path__ + "img/46_ProLAbel_PA6 .18d305ae.png";